// components/SplashWrapper.js
import { useEffect, useState } from "react";
import splashLogo from "../assets/images/SplashLogo.png";
import splashLogo2 from "../assets/images/SplashLogo2.png";

const SplashWrapper = ({ children }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [showTagline, setShowTagline] = useState(false);
  const [splash, setSplash] = useState(true);

  useEffect(() => {
    const taglineTimeout = setTimeout(() => setShowTagline(true), 1000);
    const fadeOutTimeout = setTimeout(() => setFadeOut(true), 3000);
    return () => {
      clearTimeout(taglineTimeout);
      clearTimeout(fadeOutTimeout);
    };
  }, []);

  return (
    <>
      {splash && (
        <div
          className="splashScreen"
          style={{
            opacity: fadeOut ? 0 : 1,
            display: splash ? "flex" : "none",
          }}
          onTransitionEnd={() => setSplash(false)}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: "34px" }}>
              <img src={splashLogo} alt="Vetta solutions" />
            </div>
            <div style={{ height: "40px" }}>
              {showTagline && (
                <img
                  src={splashLogo2}
                  alt="Make every step matter"
                  style={{ opacity: 0, animation: "fadeIn 0.5s forwards" }}
                />
              )}
            </div>
          </div>
        </div>
      )}
      {children}
    </>
  );
};

export default SplashWrapper;
